import { render } from "./Tipos_servicios.vue?vue&type=template&id=3894edd6&scoped=true"
import script from "./Tipos_servicios.vue?vue&type=script&lang=js"
export * from "./Tipos_servicios.vue?vue&type=script&lang=js"

import "./Tipos_servicios.vue?vue&type=style&index=0&id=3894edd6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3894edd6"]])

export default __exports__